export default {
      id: "icon-info-close-usage",
      viewBox: "0 0 17 17",
      url: __webpack_public_path__ + "dist/sprite.svg#icon-info-close",
      toString: function () {
        return this.url;
      }
    }